// src/utils/platform.ts

/**
 * Runtime platform detection helpers.
 *
 * `isAndroid()` is derived from `navigator.userAgent` (same source as
 * `isMobileDevice.ts`), not from `window.Telegram.WebApp.platform`, because
 * the latter can be `"unknown"` or `undefined` when the app is opened
 * outside Telegram.
 *
 * `applyPlatformAttr()` writes a single `<html data-platform="...">`
 * attribute used by SCSS overrides scoped via
 * `:global(html[data-platform="android"]) .ClassName { ... }`.
 *
 * Must be called synchronously at app boot, BEFORE the first render, so the
 * first paint already has the correct styles (no FOUC).
 */

export const isAndroid = (): boolean => /Android/i.test(navigator.userAgent)

export const applyPlatformAttr = (): void => {
  if (isAndroid()) {
    document.documentElement.setAttribute("data-platform", "android")
  }
}
